import { render, staticRenderFns } from "./Relocation.vue?vue&type=template&id=3b2198d6&scoped=true"
import script from "./Relocation.vue?vue&type=script&lang=js"
export * from "./Relocation.vue?vue&type=script&lang=js"
import style0 from "./Relocation.vue?vue&type=style&index=0&id=3b2198d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2198d6",
  null
  
)

export default component.exports